export const SORTABLE_ITEM_TEST_ID =
	'issue-view-layout-templates-item-list.ui.sortable-item-list.sortable-item-container-';
